import { useCallback, useState } from 'react'

import {
  SPOUSE_GOAL_PILL_UPDATE,
  SPOUSE_GOAL_PILL_LEARN_MORE,
  SPOUSE_GOAL_HELP_TEXT,
} from './spouseGoalPrompt'
import { userTurn, botTurn } from './chatTurns'

/**
 * The client-side spouse-retired help exchange (see spouseGoalPrompt.js).
 *
 * Mirrors useSalaryPrompt's contract — turns it has produced, plus a `handle`
 * the surface calls BEFORE its normal send, returning true when it has taken the
 * message so the agent never sees it. There is no write and no async work here,
 * so it has no `saving` counterpart.
 *
 * The turns outlive `enabled` on purpose: the alert clears on the user's next
 * login, and nothing should make the answer they are reading disappear.
 * `enabled` gates only whether new input is intercepted.
 *
 * @param {boolean} enabled  this alert owns the pills right now
 */
export default function useSpouseGoalPrompt({ enabled }) {
  const [turns, setTurns] = useState([])

  const handle = useCallback(
    text => {
      const trimmed = (text || '').trim()
      if (!trimmed) return false
      // Nothing to intercept once the alert is gone — a later "Learn more" from
      // some other turn's pills belongs to the agent.
      if (!enabled) return false
      if (trimmed !== SPOUSE_GOAL_PILL_LEARN_MORE) return false

      /*
       * Re-offer the other pill alongside the answer, as the salary exchange
       * does. That one is the agent's to handle; it is repeated here only so the
       * user still has it after reading the explanation.
       */
      setTurns(prev => [
        ...prev,
        userTurn(trimmed),
        botTurn(SPOUSE_GOAL_HELP_TEXT, [SPOUSE_GOAL_PILL_UPDATE]),
      ])
      return true
    },
    [enabled]
  )

  return { turns, handle }
}
